import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";

export const AddPaymentProofData = {
    name: "Add Payment Proof Data",
    initialState: {
        paymentProofFileName: '',
        profOfPaymentFile: "",
        comments: "",
    },
    section: [
        {
            title: "Add Payment Proof Data",
            row: {},
            style: {
                sectionStyle: "row verticle-form",
            },
            fields: [
                {
                    id: "profOfPaymentFile",
                    Field_Name: "profOfPaymentFile",
                    label: "",
                    fieldType: FormFieldTypes.FILE,
                    dataField: "profOfPaymentFile",
                    fieldSetting: {
                        allowMultipleFiles: false,
                        isHideFileName: true,
                        acceptedFileFormats: [
                            FileFormats.PDF,
                            FileFormats.JPG,
                            FileFormats.JPEG,
                            FileFormats.PNG,
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-4 ml-auto mt-001 file-upload-field",
                    },
                },
                {
                    id: "paymentMethod",
                    label: "Payment Method",
                    Field_Name: "Payment Method",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "paymentMethod",
                    fieldSetting: {
                        allowSpace: true,
                        options: [
                            { label: "Bank Transfer", value: 1 },
                            // { label: "Credit card", value: 2, },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "mt-3",
                    },
                },
                {
                    id: "comments",
                    label: "Comments",
                    Field_Name: "Comments",
                    fieldType: FormFieldTypes.TEXTAREA,
                    dataField: "comments",
                    fieldSetting: {
                        placeholder: "Please Enter Comment",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "mt-3 mb-4",
                    },
                },
            ],
        },
    ],
};
